import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import RoomDetails from '../Common/RoomDetails'

import FoldableContent from 'components/Common/FoldableContent/FoldableContent'
import { BaseImage } from 'components/Common/OrderView/styles'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'

const BookingDetails = styled.div`
  padding: ${rem(20)} 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
`

interface Prop {
  offer: App.Offer
  pkg: App.Package
}

function PlannedLeOfferPackageSummary({ offer, pkg }: Prop) {
  const imageId = pkg.roomType?.images[0]?.id || offer.image.id
  return (
    <BookingDetails>
      <Heading variant="heading5">Your Package</Heading>
      {imageId && (
        <BaseImage
          className="hidden-print"
          id={imageId}
          mobileAspectRatio="9:4"
          mobileWidth="100"
        />
      )}
      <BodyText variant="medium" weight="bold">
        {pkg.name}
      </BodyText>
      {pkg.roomType && (
        <BodyText variant="medium">{pkg.roomType?.name}</BodyText>
      )}
      <FoldableContent
        openLabel="Hide package and room details"
        closedLabel="View package and room details"
      >
        <RoomDetails pkg={pkg} />
      </FoldableContent>
    </BookingDetails>
  )
}

export default PlannedLeOfferPackageSummary
